import React from 'react';
import './ViewToggleButtons.scss';
import { ToolbarIconWithText } from '@instinet-analytics/semantic-ui-components';
import { IconNames } from '@instinet-analytics/semantic-ui-components';

export type GridChartView = 'chart' | 'grid';
export type GridChartTreemapView = GridChartView | 'treemap';
interface ButtonDetail<Tview extends string> {
    view: Tview;
    icon: IconNames;
    text: string;
}

const createViewToggleButtons =
    <Tview extends string>(options: ButtonDetail<Tview>[]) =>
    (currentView: Tview, onViewChanged: (view: Tview) => void) => {
        return options
            .filter((v) => currentView !== v.view)
            .map((v) => (
                <div className="ViewToggleButtons" key={v.view}>
                    <ToolbarIconWithText
                        name={v.icon}
                        onClick={() => onViewChanged(v.view)}
                        tooltip={{ body: v.text }}
                        text={v.text}
                        className={`view-${v.view}`}
                    />
                </div>
            ));
    };

const chartOption: ButtonDetail<GridChartView> = {
    view: 'chart',
    icon: 'chart bar',
    text: 'View as Chart',
};
const gridOption: ButtonDetail<GridChartView> = {
    view: 'grid',
    icon: 'th list',
    text: 'View as Table',
};
const treemapOption: ButtonDetail<GridChartTreemapView> = {
    view: 'treemap',
    icon: 'th',
    text: 'View as Treemap',
};

export const createGridChartViewToggleButtons = createViewToggleButtons([
    chartOption,
    gridOption,
]);
export const createGridChartTreemapViewToggleButtons = createViewToggleButtons([
    chartOption,
    gridOption,
    treemapOption,
]);
